export default __webpack_public_path__ + "static/media/airbnb.a09d3cf7.svg";